import styled from 'styled-components';

export const Wrapper = styled.div`
    height: calc(100% - 106px - 8px);
`;

export const Title = styled.div`
    padding: 12px;
    font-size: 16px;
    font-weight: bold;
    color: #333;
    background-color: #fff;
    height: 50px;
`;

export const Content = styled.div`
    height: calc(100% - 50px);

    p {
        margin: 0;
    }
    .udesk-qa-ui-tabs-card .udesk-qa-ui-tabs-content {
        height: 100%;
    }
    .udesk-qa-ui-tabs-card .udesk-qa-ui-tabs-content > .udesk-qa-ui-tabs-tabpane {
        padding: 12px;
        background: #fff;
    }
    .udesk-qa-ui-tabs-card > .udesk-qa-ui-tabs-nav::before {
        display: none;
    }
    .udesk-qa-ui-tabs-card .udesk-qa-ui-tabs-tab,
    [data-theme='compact'] .udesk-qa-ui-tabs-card .udesk-qa-ui-tabs-tab {
        background: transparent;
        border-color: transparent;
        margin-top: 0px !important;
        border: 0 !important;
    }
    .udesk-qa-ui-tabs-card .udesk-qa-ui-tabs-tab-active,
    [data-theme='compact'] .udesk-qa-ui-tabs-card .udesk-qa-ui-tabs-tab-active {
        background: #fff;
        border-color: #fff;
    }
    #components-tabs-demo-card-top .code-box-demo {
        padding: 24px;
        overflow: hidden;
        background: #f5f5f5;
    }
    [data-theme='compact'] .udesk-qa-ui-tabs-card .udesk-qa-ui-tabs-content {
        height: 120px;
        margin-top: -8px;
    }
    [data-theme='dark'] .udesk-qa-ui-tabs-card .udesk-qa-ui-tabs-tab {
        background: transparent;
        border-color: transparent;
        margin-top: 0px !important;
        border: 0 !important;
    }
    [data-theme='dark'] #components-tabs-demo-card-top .code-box-demo {
        background: #000;
    }
    [data-theme='dark']
        .udesk-qa-ui-tabs-card
        .udesk-qa-ui-tabs-content
        > .udesk-qa-ui-tabs-tabpane {
        background: #141414;
    }
    [data-theme='dark'] .udesk-qa-ui-tabs-card .udesk-qa-ui-tabs-tab-active {
        background: #141414;
        border-color: #141414;
    }

    .udesk-qa-ui-tabs-card > .udesk-qa-ui-tabs-nav .udesk-qa-ui-tabs-tab {
        background: transparent;
    }

    .udesk-qa-ui-tabs-card.udesk-qa-ui-tabs-left
        > .udesk-qa-ui-tabs-nav
        .udesk-qa-ui-tabs-tab-active {
        background: #fff;
    }

    .udesk-qa-ui-tabs-left
        > .udesk-qa-ui-tabs-content-holder
        > .udesk-qa-ui-tabs-content
        > .udesk-qa-ui-tabs-tabpane {
        padding: 0px;
    }

    .udesk-qa-ui-tabs-card > .udesk-qa-ui-tabs-nav .udesk-qa-ui-tabs-tab {
        padding: 8px 0;
    }

    .udesk-qa-ui-tabs-nav {
        width: 80px;
    }

    .udesk-qa-ui-tabs-tab {
        justify-content: center;
    }
`;
